export * from "./date";
export * from "./number";
export * from "./toasts";

export function createArrayWithNumbers(length: number) {
  return Array.from({ length }, (_, k) => k + 1);
}

export function arrayRegExpCheck(
  arr: string[],
  check?: string | null,
): boolean {
  if (!check) {
    return false;
  }
  return arr?.map((re) => new RegExp(re).test(check)).includes(true);
}

export function isActive(pathname: string, compare: string): boolean {
  if (pathname === "/") {
    return compare === "/" || compare === "";
  }

  if (compare.length > 1) {
    return pathname.startsWith(compare);
  }

  return false;
}
